import { render, staticRenderFns } from "./CurrentGauge.vue?vue&type=template&id=a2e71e24"
import script from "./CurrentGauge.vue?vue&type=script&lang=js"
export * from "./CurrentGauge.vue?vue&type=script&lang=js"
import style0 from "./CurrentGauge.vue?vue&type=style&index=0&id=a2e71e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports